(() => {
  const scrolledClass = "epsoak-scrolled";
  const enterAt = 80;
  const leaveAt = 16;
  const isHomepage = document.body.classList.contains("index");

  if (!isHomepage) {
    document.documentElement.classList.add(scrolledClass);
    return;
  }

  let scrolled = window.scrollY > enterAt;
  const root = document.documentElement;
  root.classList.toggle(scrolledClass, scrolled);

  const update = () => {
    const y = window.scrollY;
    if (!scrolled && y > enterAt) {
      scrolled = true;
      root.classList.add(scrolledClass);
    } else if (scrolled && y < leaveAt) {
      scrolled = false;
      root.classList.remove(scrolledClass);
    }
  };

  window.addEventListener("scroll", update, { passive: true });
})();

(() => {
  const root = document.querySelector("[data-epsoak-search]");
  if (!root) return;

  const toggle = root.querySelector("[data-epsoak-search-toggle]");
  const input = root.querySelector("[data-epsoak-search-input]");
  if (!toggle || !input) return;

  const setOpen = (open) => {
    root.classList.toggle("is-open", open);
    toggle.setAttribute("aria-expanded", open ? "true" : "false");
    if (open) {
      window.requestAnimationFrame(() => input.focus());
    } else {
      input.blur();
    }
  };

  root.addEventListener("click", (event) => {
    if (event.target.closest("[data-epsoak-search-close]")) {
      event.preventDefault();
      event.stopPropagation();
      setOpen(false);
      toggle.focus();
      return;
    }

    if (event.target.closest("[data-epsoak-search-toggle]")) {
      event.preventDefault();
      event.stopPropagation();
      setOpen(true);
    }
  });

  document.addEventListener("click", (event) => {
    if (!root.contains(event.target)) setOpen(false);
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && root.classList.contains("is-open")) {
      setOpen(false);
      toggle.focus();
    }
  });
})();
